import { render } from "./WorkExperience.vue?vue&type=template&id=580c3085&scoped=true"
import script from "./WorkExperience.vue?vue&type=script&lang=js"
export * from "./WorkExperience.vue?vue&type=script&lang=js"

import "./WorkExperience.vue?vue&type=style&index=0&id=580c3085&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580c3085"]])

export default __exports__